import {IOperations} from '@baidu/icloud-ui-pro-table';

// 操作区
export const useOperations = (total: number, selectedRowKeys: any): IOperations => {
    return [
        {
            render: () => {
                return <span>已选中{selectedRowKeys.length}条，共{total}条</span>;
            },
        },
    ];
};
